export default {
  title: 'RÉSULTATS DE RECHERCHE',
  totalResult: {
    label: 'RÉSULTATS',
  },
  tabs: {
    product: 'Produits',
    provider: 'Producteurs',
    blogs: 'Blogues',
  }
};
